import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import { filterChanged } from 'common/actions'
import { brandSelector, configCompanyUuidSelector } from 'embed/selectors/config'
import { CNBC_COMPANY_UUID, ContactEven, ContactFiona } from 'embed/constants'
import { formattedPhoneNumber } from 'embed/utils'
import { Brand, Filter, Product } from 'even-ts-static'
const styles = require('embed/styles/application')

interface Props {
  brand: Brand
  isCNBC: boolean
  buttonText: string
  children?: React.ReactNode
  className?: string
  dispatchTCPALanguageChanged: (product: Product, language: string) => void
  product: Product
}

export const TCPALanguageView: React.FC<Props> = (props) => {
  React.useEffect(() => {
    const { dispatchTCPALanguageChanged, product } = props
    dispatchTCPALanguageChanged(product, language().text)
  }, [])
  const language = () => {
    const { brand, buttonText, isCNBC } = props

    let name: string
    let phone: string
    let url: string
    if (brand === Brand.Fiona) {
      name = ContactFiona.Name
      phone = ContactFiona.Phone
      url = ContactFiona.Url
    } else {
      name = ContactEven.Name
      phone = ContactEven.Phone
      url = ContactEven.Url
    }

    return {
      html: (
        <>
          <span>
            By clicking {buttonText}, I hereby consent to the{' '}
            <a href={`${url}/electronic-consent/`} target="_blank">
              "E-Sign Agreement"
            </a>
            , the{' '}
            <a href={`${url}/credit-authorization-agreement/`} target="_blank">
              "Credit Authorization Agreement"
            </a>
            , the{' '}
            <a href={`${url}/terms-of-service/`} target="_blank">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href={`${url}/privacy-policy/`} target="_blank">
              Privacy Policy
            </a>
            , and am providing written consent under the FCRA for {name}, and its{' '}
            <a href={`${url}/providers/`} target="_blank">
              partners
            </a>{' '}
            to obtain consumer report information from my credit profile. I agree to be contacted by {name} and its{' '}
            <a href={`${url}/providers/`} target="_blank">
              partners
            </a>{' '}
            and their affiliated companies via email and/or at the telephone number(s) I have provided above to explore
            various financial products and services I inquired about, including contact through automatic dialing
            systems, systems, artificial or pre-recorded voice messaging, or text message. Consent is not required as a
            condition to utilize {name}, and you may choose to be contacted by an individual customer care
            representative(s) by calling {formattedPhoneNumber(phone)}.
          </span>
          {isCNBC && (
            <span
              className={css`
                text-decoration: underline;
                font-weight: bold !important;
              `}
            >
              Even Financial determines the selection and order of offers presented through this tool. CNBC Select may
              receive a commission when you click on links for products from its affiliate partners.
            </span>
          )}
        </>
      ),
      text:
        `By clicking ${buttonText}, I hereby consent to the "E-Sign Agreement", the "Credit Authorization Agreement", ` +
        `the Terms of Service and Privacy Policy, and am providing written consent under the FCRA for ${name}, and its ` +
        `partners to obtain consumer report information from my credit profile. I agree to be contacted by ${name}. and ` +
        `its partners and their affiliated companies via email and/or at the telephone number(s) I have provided above ` +
        `to explore various financial products and services I inquired about and/or that may be of interest to me, ` +
        `including contact through automatic dialing systems, artificial or pre-recorded voice ` +
        `messaging, or text message. Consent is not required as a condition to utilize ${name}, and you may choose to be` +
        `contacted by an individual customer care representative(s) by calling ${formattedPhoneNumber(phone)}.

Button text: ${buttonText}`,
    }
  }

  const { children, className } = props

  return (
    <div className={classnames(styles.formRow, styles.consentField, className)}>
      <label>{language().html}</label>
      {children}
    </div>
  )
}

const mapStateToProps = (state) => ({
  brand: brandSelector(state),
  isCNBC: configCompanyUuidSelector(state) === CNBC_COMPANY_UUID,
})

const mapDispatchToProps = (dispatch) => ({
  dispatchTCPALanguageChanged: (product: Product, language: string) =>
    dispatch(filterChanged(product, Filter.TCPALanguage, language)),
})

export const TCPALanguage = connect(mapStateToProps, mapDispatchToProps)(TCPALanguageView)
